<template lang="pug">
div
  ul#reviewtab.nav.nav-tabs(role='tablist')
    li.nav-item(@click="refresh('reviewlist')")
      a#reviewlist-tab.nav-link.active(data-toggle='tab' href='#reviewlist-content' role='tab' aria-controls='reviewlist' aria-selected='false') {{ $t("ui.review_list") }}
    li.nav-item(@click="refresh('monthlyrating')")
      a#monthlyrating-tab.nav-link(data-toggle='tab' href='#monthlyrating-content' role='tab' aria-controls='monthlyrating' aria-selected='false') {{ $t("ui.monthly_rating") }}
    li.nav-item(@click="refresh('surveylist')")
      a#surveylist-tab.nav-link(data-toggle='tab' href='#surveylist-content' role='tab' aria-controls='surveylist' aria-selected='false') {{ $t("ui.survey_list") }}

  #reviewtabcontent.tab-content.tab-bordered
    #reviewlist-content.tab-pane.active.show(role='tabpanel' aria-labelledby='reviewlist-tab')
      reviewListTab(ref="reviewListTab")
    #monthlyrating-content.tab-pane.fade(role='tabpanel' aria-labelledby='monthlyrating-tab')
      monthlyRatingTab(ref="monthlyRatingTab")
    #surveylist-content.tab-pane.fade(role='tabpanel' aria-labelledby='surveylist-tab')
      surveyListTab(ref="surveyListTab")

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import reviewListTab from "@/components/reviewTab/reviewListTab.vue";
import monthlyRatingTab from "@/components/reviewTab/monthlyRatingTab.vue";
import surveyListTab from "@/components/reviewTab/surveyListTab.vue";
import SubmitButton from "@/library/SubmitButton.vue";

export default {
  components: {
    SubmitButton,
    reviewListTab,
    monthlyRatingTab,
    surveyListTab
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
  }),
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    }
  },
  mounted: function() {
    // this.getBannerList(true);
  },
  methods: {
    refresh: function(tab) {
      switch(tab) {
        case 'reviewlist':
          if(this.$refs.reviewListTab) {
            this.$refs.reviewListTab.refresh();
          }
          break
        case 'monthlyrating':
          if(this.$refs.monthlyRatingTab) {
            this.$refs.monthlyRatingTab.refresh();
          }
          break
        case 'surveylist':
          if(this.$refs.surveyListTab) {
            this.$refs.surveyListTab.refresh();
          }
          break
      }
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>